import { useAuth } from './contexts/auth'

export default function NotAllowed() {
	const { notAllowed } = useAuth()
	return (
		<div className={'content-block'}>
			<h2>
				<span className={'dx-icon-lock'} style={{ fontSize: '24px' }}></span>
				{` `}
				Prohibited Access
			</h2>
			<h5 style={{ color: 'red' }}>{notAllowed}</h5>
		</div>
	)
}
